import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { IProductConfigurableSelection, IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { filterMediaByLabel } from '@df/ui/common/filter-media-by-label-pipe';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from 'projects/app-default/src/app/catalog/model/product/product.decorator';
import { BuilderProductConfigurableOptionsComponent } from '../configurable-options/builder-product-configurable-options.component';
@Component({
    selector: 'builder-product-preview',
    templateUrl: 'builder-product-preview.html',
    styleUrls: ['./builder-product-preview.scss'],
    standalone: true,
    imports: [CarouselModule, ImageModule, TranslationModule, PriceComponent, HrefComponent, BuilderProductConfigurableOptionsComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuilderProductPreviewComponent extends ProductComponentDef<LocalProduct<IProductDataV3>> implements OnInit {
    @Input()
    existingSelection?: IProductConfigurableSelection;
    override ngOnInit(): void {
        super.ngOnInit();
        if (this.existingSelection) {
            this.selection = { ...this.existingSelection };
            this.onSelectionChange(this.selection);
        }
    }
    get images() {
        return (
            filterMediaByLabel(
                this.model.media.filter(item => !item.video),
                ['landscape', 'outfit_builder_additional', 'outfit_builder_image'],
                true
            ) || []
        );
    }
}
